import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Save, Settings } from 'lucide-react';
import './Admin.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const adminFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('adminToken');
  if (!token) { window.location.href = '/admin/login'; return null; }
  const res = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, ...options.headers },
  });
  if (res.status === 401) { localStorage.removeItem('adminToken'); window.location.href = '/admin/login'; return null; }
  return res;
};

const AdminSettings = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);
  const [flash, setFlash] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) { navigate('/admin/login'); return; }
    loadSettings();
  }, [navigate]);

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => { if (meta.parentNode) meta.parentNode.removeChild(meta); };
  }, []);

  const loadSettings = async () => {
    const res = await adminFetch('/api/admin/settings');
    if (res && res.ok) setSettings(await res.json());
  };

  const handleSave = async () => {
    setSaving(true);
    const res = await adminFetch('/api/admin/settings', {
      method: 'PUT',
      body: JSON.stringify(settings),
    });
    if (res && res.ok) {
      setFlash('Einstellungen gespeichert');
      setTimeout(() => setFlash(''), 3000);
    }
    setSaving(false);
  };

  const updateField = (field, value) => {
    setSettings(prev => ({ ...prev, [field]: value }));
  };

  if (!settings) return <div className="admin-dashboard"><div className="admin-loading"><div className="admin-loading-spinner"></div>Wird geladen...</div></div>;

  return (
    <div className="admin-dashboard" data-testid="admin-settings-page">
      {flash && <div className="admin-success-flash">{flash}</div>}
      <div className="admin-topbar">
        <div className="admin-topbar-left">
          <button className="admin-back-nav" onClick={() => navigate('/admin/dashboard')} data-testid="back-to-dashboard"><ArrowLeft size={18} /> Dashboard</button>
          <span className="admin-topbar-logo"><Settings size={18} /> Einstellungen</span>
        </div>
        <div className="admin-topbar-right">
          <button className="admin-export-btn" onClick={handleSave} disabled={saving} data-testid="save-settings-btn">
            <Save size={16} /> {saving ? 'Speichern...' : 'Speichern'}
          </button>
        </div>
      </div>
      <div className="admin-main">
        <div className="settings-grid" data-testid="settings-grid">
          <div className="settings-card">
            <h3>Kontaktdaten</h3>
            <div className="settings-field">
              <label>WhatsApp Nummer (ohne +, z.B. 491793912947)</label>
              <input type="text" value={settings.whatsappNumber || ''} onChange={(e) => updateField('whatsappNumber', e.target.value)} data-testid="setting-whatsapp" />
            </div>
            <div className="settings-field">
              <label>Kontakt-Telefon (Anzeige)</label>
              <input type="text" value={settings.contactPhone || ''} onChange={(e) => updateField('contactPhone', e.target.value)} data-testid="setting-phone" />
            </div>
            <div className="settings-field">
              <label>Kontakt E-Mail</label>
              <input type="email" value={settings.contactEmail || ''} onChange={(e) => updateField('contactEmail', e.target.value)} data-testid="setting-email" />
            </div>
          </div>
          <div className="settings-card">
            <h3>Tracking</h3>
            <div className="settings-field">
              <label>Google Tag Manager ID (z.B. GTM-XXXXXXX)</label>
              <input type="text" value={settings.gtmId || ''} onChange={(e) => updateField('gtmId', e.target.value)} placeholder="GTM-XXXXXXX" data-testid="setting-gtm" />
            </div>
            <div className="settings-field">
              <label>Meta Pixel ID</label>
              <input type="text" value={settings.metaPixelId || ''} onChange={(e) => updateField('metaPixelId', e.target.value)} placeholder="Pixel ID eingeben" data-testid="setting-pixel" />
            </div>
            <p className="settings-hint">Nach dem Speichern werden Tracking-Codes automatisch in die Webseite eingebunden.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
